import React, { useState } from 'react';
import Modal from '../Modal';

const PopUp = ({ linkText, modalText, imgUrl }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div className="pop-up">
                { imgUrl && (<img className="icon" src={imgUrl} alt="popup" />)}
                <p className="pop-up-trigger" onClick={() => setIsOpen(!isOpen)}>
                    {linkText}
                </p>
            </div>
            <Modal isOpen={isOpen} setIsOpen={() => setIsOpen(!isOpen)} modalText={modalText} />
        </>
    );
};

export default PopUp;
